<ng-container>
    <form [formGroup]="exchangeForm">
        <div class="p-p-3">
            <div class="p-mb-2">Exchange Rate (in {{vendorDetails?.currencyUnit?.code}})<span class="text-red-custom">*</span></div>
            <input type="text" pInputText class="w-100" formControlName="exchangeRate" appDecimalNumber/>
            <div *ngIf="exchangeForm.get('exchangeRate').invalid && exchangeForm.get('exchangeRate').dirty">
                <small class="p-error" *ngIf="exchangeForm.get('exchangeRate').errors.required">
                    Exchange Rate is required.
                </small>
                <small class="p-error" *ngIf="exchangeForm.get('exchangeRate').errors.min">
                    Exchange Rate must be greater than 0.
                </small>
            </div>
            <div class="p-d-flex p-mt-2">
                <p-checkbox formControlName="defaultRateEnabled" binary="true" inputId="set" class="p-mr-2"> </p-checkbox>
                <div class="p-mt-1">Set this rate as default for {{todaysData | date: 'MM/dd/YYYY'}}</div>
            </div>
            <div class="p-d-flex p-my-2">
                <p-checkbox formControlName="enableRecalculateItemRate" binary="true" inputId="recalculate" class="p-mr-2"> </p-checkbox>
                <div class="p-mt-1">Re-calculate item prices based on this rate</div>
            </div>
            <p-button label="Save" [disabled]="!exchangeForm.valid" (click)="saveExchangeRate(exchangeForm.value)"></p-button>
        </div>
    </form>
</ng-container>